export enum ScheduledPaymentListTabsEnum {
  DRAFT = 'draft',
  OPEN = 'open',
  COMPLETED = 'completed',
  CANCELED = 'canceled',
  DELETED = 'deleted',
  ALL = 'all',
}
